import { InputHTMLAttributes } from 'react'
import { RegisterOptions } from 'react-hook-form'

import { langCodes } from '../../utils/siteSettings'
import { SelectFieldOption } from './types'

// limitation imposed by NS
export const ADDRESS_MAX_LENGTH = 150

export const addressMaxLengthProp: Pick<InputHTMLAttributes<HTMLElement>, 'maxLength'> = {
  maxLength: ADDRESS_MAX_LENGTH,
}

export const addressMaxLengthRule: Pick<RegisterOptions, 'maxLength'> = {
  maxLength: {
    value: ADDRESS_MAX_LENGTH,
    message: `Length must not exceed ${ADDRESS_MAX_LENGTH} characters`,
  },
}

export const addressNameRule: Pick<RegisterOptions, 'pattern'> = {
  pattern: {
    value: /^.*[a-zA-Z0-9]+.*$/,
    message: `Name must contain at least one letter or number`,
  },
}

export const countryOptions = {
  US: {
    value: 'US',
    label: 'United States',
  },
  CA: {
    value: 'CA',
    label: 'Canada',
  },
  AU: {
    value: 'AU',
    label: 'Australia',
  },
}

export const countryOptionsFor = (
  lang: string | undefined | null,
): { options: SelectFieldOption[]; defaultOption: SelectFieldOption } => {
  switch (lang) {
    case langCodes.en_US:
      return { options: [countryOptions.US], defaultOption: countryOptions.US }
    case langCodes.en_CA:
      return { options: [countryOptions.CA], defaultOption: countryOptions.CA }
    case langCodes.en_AU:
      return { options: [countryOptions.AU], defaultOption: countryOptions.AU }
    default:
      return { options: [countryOptions.US], defaultOption: countryOptions.US }
  }
}

export const determineFieldLabels = (
  lang: string | undefined | null,
): { zipCode: string; state: string } => {
  switch (lang) {
    case langCodes.en_US:
      return {
        zipCode: 'Zip Code',
        state: 'State',
      }
    case langCodes.en_CA:
      return {
        zipCode: 'Postal Code',
        state: 'Province',
      }
    default:
      return {
        zipCode: 'Postal Code',
        state: 'Region',
      }
  }
}
